import { Section, Shimmer, Card } from '@soteria/design-system-ve';

import * as shimmerStyles from '../shared/shimmer.css';

import * as styles from './AuditItemSection.css';

/**
 * AuditItemShimmer component - Accurate shimmer loading state
 * Matches the actual structure of audit items with proper CSS classes
 */
export function AuditItemShimmer() {
  return (
    <Section>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionHeaderLeft}>
          <Shimmer className={shimmerStyles.shimmerSectionTitle} />
        </div>
        <div className={styles.progressStats}>
          {[1, 2, 3, 4].map(index => (
            <div key={`stat-${index}`} className={shimmerStyles.shimmerStatGroup}>
              <Shimmer className={shimmerStyles.shimmerLabel} />
              <Shimmer className={shimmerStyles.shimmerSmallValue} />
            </div>
          ))}
        </div>
        <div className={styles.progressInfo}>
          <Shimmer className={shimmerStyles.shimmerSectionTitle} />
          <Shimmer className={shimmerStyles.shimmerProgressBar} />
        </div>
      </div>

      <div className={styles.auditItemsList}>
        {/* Render 3 accurate shimmer audit items */}
        {[1, 2, 3].map(index => (
          <Card key={`shimmer-${index}`} className={shimmerStyles.shimmerCard}>
            <div className={shimmerStyles.shimmerCardHeader}>
              <Shimmer className={shimmerStyles.shimmerBadge} />
              <Shimmer className={shimmerStyles.shimmerButton} />
            </div>
            <div className={shimmerStyles.shimmerCardContent}>
              <Shimmer className={shimmerStyles.shimmerContentBlock} />
              <Shimmer className={shimmerStyles.shimmerContentBlock} />
            </div>
            <div className={shimmerStyles.shimmerCardHeader}>
              <Shimmer className={shimmerStyles.shimmerButton} />
            </div>
          </Card>
        ))}
      </div>
    </Section>
  );
}
